import { UsersService } from '@/services/users.service';
import { appendAlert } from '@/plugins/alert';
//import { getCurrentInstance } from 'vue';

export function useLoginSuccess(store, router) {  
//   const instance = getCurrentInstance();
//   const store = instance?.proxy?.$store;

  const onLoginSuccess = async () => {
    console.log('onLoginSuccess')
        
    let userInfo;

    // Получаем информацию о пользователе
    try {
      const res = await UsersService.getCurrent();
      userInfo = res?.data;      
      commit('SET_CURRENT_USER', userInfo)
    } catch (e) {
      console.error('Ошибка получения данных пользователя:', e);
    }        

    if (userInfo && !userInfo.isPasswordSet) {
      appendAlert('Установите пароль в личном кабинете', 'success');
    }

    store.dispatch('popup/showPopupIfNeeded');

    await router.push('/finances/payslips');    
  };

  return { onLoginSuccess };
}
